var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _line2, _path50, _path51, _line3, _line4, _path52, _path53, _line5, _line6, _path54, _path55, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridIcons1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1127,
    height: 552,
    viewBox: "0 0 1127 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1127,
    height: 552,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.062 191.979C511.062 177.011 517.009 162.656 527.593 152.072C538.177 141.488 552.532 135.542 567.5 135.542C582.468 135.542 596.823 141.488 607.407 152.072C617.991 162.656 623.938 177.011 623.938 191.979V210.792H680.375V411.458H454.625V210.792H511.062V191.979ZM511.062 235.875H479.708V386.375H655.292V235.875H623.938V273.5H598.854V235.875H536.146V273.5H511.062V235.875ZM598.854 210.792V191.979C598.854 183.664 595.551 175.689 589.671 169.809C583.791 163.928 575.816 160.625 567.5 160.625C559.184 160.625 551.209 163.928 545.329 169.809C539.449 175.689 536.146 183.664 536.146 191.979V210.792H598.854Z",
    fill: "#C8D2D7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 417.204,
    y: 123.184,
    width: 301.02,
    height: 12.0408,
    fill: "#B4DDF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 417.204,
    y: 412.163,
    width: 301.02,
    height: 12.0408,
    fill: "#B4DDF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 417.204,
    y: 424.204,
    width: 301.02,
    height: 12.0408,
    transform: "rotate(-90 417.204 424.204)",
    fill: "#B4DDF3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 706.184,
    y: 424.204,
    width: 301.02,
    height: 12.0408,
    transform: "rotate(-90 706.184 424.204)",
    fill: "#B4DDF3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 416.704,
    y: 122.684,
    width: 302.02,
    height: 302.02,
    stroke: "#8C9BA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.748 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 411.662L417.205 411.662",
    stroke: "#8C9BA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 399.118L417.205 399.118",
    stroke: "#8C9BA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 386.576L417.205 386.576",
    stroke: "#8C9BA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 374.034L417.205 374.034",
    stroke: "#8C9BA0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 361.491L417.205 361.491",
    stroke: "#8C9BA0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 348.948L417.205 348.948",
    stroke: "#8C9BA0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 336.406L417.205 336.406",
    stroke: "#8C9BA0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 323.863L417.205 323.863",
    stroke: "#8C9BA0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 311.322L417.205 311.322",
    stroke: "#8C9BA0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 298.779L417.205 298.779",
    stroke: "#8C9BA0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 286.235L417.205 286.235",
    stroke: "#8C9BA0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 273.694L417.205 273.694",
    stroke: "#8C9BA0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 261.151L417.205 261.151",
    stroke: "#8C9BA0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 248.608L417.205 248.608",
    stroke: "#8C9BA0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 236.066L417.205 236.066",
    stroke: "#8C9BA0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 223.524L417.205 223.524",
    stroke: "#8C9BA0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 210.98L417.205 210.98",
    stroke: "#8C9BA0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 198.439L417.205 198.439",
    stroke: "#8C9BA0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 185.896L417.205 185.896",
    stroke: "#8C9BA0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 173.353L417.205 173.353",
    stroke: "#8C9BA0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 160.811L417.205 160.811",
    stroke: "#8C9BA0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 148.269L417.205 148.269",
    stroke: "#8C9BA0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M718.225 135.726L417.205 135.726",
    stroke: "#8C9BA0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M467.376 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M505.003 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M542.631 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M580.258 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M617.885 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M655.512 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M693.14 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M705.68 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M442.287 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M479.915 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M517.543 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M555.17 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M592.798 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M630.426 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M668.053 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M454.831 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M492.459 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M530.087 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M567.714 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M642.97 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M680.597 123.184V424.204",
    stroke: "#8C9BA0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M713.628 74.4917V85H712.355V75.8257H712.294L709.728 77.5292V76.2362L712.355 74.4917H713.628Z",
    fill: "#37464B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M705.394 97.02L718.225 97.02",
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 718.413,
    y1: 91,
    x2: 718.413,
    y2: 113.878,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 705.582,
    y1: 91,
    x2: 705.582,
    y2: 113.878,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M764.199 123.471V133.979H762.927V124.805H762.865L760.3 126.509V125.216L762.927 123.471H764.199Z",
    fill: "#37464B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M744.715 122.394L744.715 135.225",
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 750.734,
    y1: 135.413,
    x2: 727.857,
    y2: 135.413,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 750.734,
    y1: 122.582,
    x2: 727.857,
    y2: 122.582,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M358.191 278.092V277.168L361.66 273.371C362.067 272.927 362.402 272.54 362.665 272.212C362.929 271.88 363.124 271.569 363.25 271.278C363.38 270.984 363.445 270.676 363.445 270.354C363.445 269.985 363.356 269.665 363.179 269.395C363.004 269.124 362.765 268.916 362.46 268.769C362.156 268.622 361.814 268.548 361.434 268.548C361.03 268.548 360.678 268.632 360.377 268.8C360.079 268.964 359.849 269.195 359.684 269.492C359.524 269.79 359.443 270.139 359.443 270.539H358.232C358.232 269.923 358.374 269.383 358.658 268.918C358.942 268.452 359.329 268.09 359.818 267.83C360.31 267.57 360.863 267.44 361.475 267.44C362.091 267.44 362.636 267.57 363.112 267.83C363.587 268.09 363.96 268.44 364.23 268.882C364.501 269.323 364.636 269.814 364.636 270.354C364.636 270.741 364.566 271.119 364.425 271.488C364.289 271.854 364.049 272.263 363.707 272.714C363.368 273.163 362.898 273.71 362.296 274.356L359.936 276.881V276.963H364.821V278.092H358.191ZM366.468 275.937V274.89L371.085 267.583H371.845V269.205H371.332L367.843 274.726V274.808H374.061V275.937H366.468ZM371.414 278.092V275.619V275.131V267.583H372.625V278.092H371.414Z",
    fill: "#37464B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M390.653 424.053L390.653 122.13",
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 384.633,
    y1: 122.582,
    x2: 407.51,
    y2: 122.582,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 384.633,
    y1: 423.451,
    x2: 407.51,
    y2: 423.451,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M559.304 477.53V476.607L562.772 472.81C563.179 472.365 563.514 471.978 563.778 471.65C564.041 471.318 564.236 471.007 564.363 470.716C564.493 470.422 564.558 470.114 564.558 469.793C564.558 469.423 564.469 469.103 564.291 468.833C564.116 468.563 563.877 468.354 563.573 468.207C563.268 468.06 562.926 467.987 562.546 467.987C562.143 467.987 561.79 468.07 561.489 468.238C561.192 468.402 560.961 468.633 560.797 468.931C560.636 469.228 560.555 469.577 560.555 469.977H559.345C559.345 469.362 559.487 468.821 559.77 468.356C560.054 467.891 560.441 467.528 560.93 467.268C561.423 467.008 561.975 466.878 562.587 466.878C563.203 466.878 563.749 467.008 564.224 467.268C564.7 467.528 565.073 467.879 565.343 468.32C565.613 468.761 565.748 469.252 565.748 469.793C565.748 470.179 565.678 470.557 565.538 470.927C565.401 471.293 565.161 471.701 564.819 472.153C564.481 472.601 564.01 473.148 563.408 473.795L561.048 476.319V476.401H565.933V477.53H559.304ZM567.58 475.375V474.329L572.198 467.022H572.957V468.643H572.444L568.955 474.164V474.246H575.174V475.375H567.58ZM572.526 477.53V475.057V474.57V467.022H573.737V477.53H572.526Z",
    fill: "#37464B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M718.074 450.693L416.151 450.693",
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 416.602,
    y1: 456.714,
    x2: 416.602,
    y2: 433.836,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 717.472,
    y1: 456.714,
    x2: 717.472,
    y2: 433.836,
    stroke: "#37464B",
    strokeWidth: 1.20408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcons1);
export default __webpack_public_path__ + "static/media/grid-icons-1.37b357902e13f8f8625f60a9082ff954.svg";
export { ForwardRef as ReactComponent };